import { render, staticRenderFns } from "./ChannelSectionTitle.vue?vue&type=template&id=1205e53c&scoped=true&"
import script from "./ChannelSectionTitle.vue?vue&type=script&lang=js&"
export * from "./ChannelSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSectionTitle.vue?vue&type=style&index=0&id=1205e53c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1205e53c",
  null
  
)

export default component.exports